import React, { useState } from "react";
import Chip from "@mui/material/Chip";
import styles from "./StyledKPIChip.module.css";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import IconButton from "@mui/material/IconButton";
import * as constants from "../../constants";

/* 
    Generic Component
    Expected Props: 
        isAdmin; label; onDelete; isMeddiccChip;

*/

const StyledKPIChip = (props) => {
  const [display, setDisplay] = useState(false);
  const showButton = (e) => {
    e.preventDefault();
    setDisplay(true);
  };

  const hideButton = (e) => {
    e.preventDefault();
    setDisplay(false);
  };

  return (
    <Chip
      className={
        props.polarity.toLowerCase() === constants.POLARITY_POSITIVE.toLowerCase()
          ? styles.pChipMain
          : props.polarity.toLowerCase() === constants.POLARITY_NEGATIVE.toLowerCase()
          ? styles.nChipMain
          : styles.tChipMain
      }
      label={
        <div className={props.isAdmin ? (display ? styles.chipHover : undefined) : styles.disabledButton}>
          <span
            className={
              props.polarity.toLowerCase() === constants.POLARITY_POSITIVE.toLowerCase()
                ? styles.pchipLabel
                : props.polarity.toLowerCase() === constants.POLARITY_NEGATIVE.toLowerCase()
                ? styles.nchipLabel
                : styles.tchipLabel
            }
          >
            {props.label}
          </span>
        </div>
      }
      onMouseEnter={(e) => showButton(e)}
      onMouseLeave={(e) => hideButton(e)}
      icon={
        <div className={display ? styles.displayed : styles.notdisplayed}>
          {props.isAdmin ? (
            <IconButton onClick={props.onDelete} className={styles.buttonContainer} fontSize="small">
              <CloseRoundedIcon color="primary" fontSize="small" sx={{ color: "white" }} />
            </IconButton>
          ) : undefined}
        </div>
      }
    ></Chip>
  );
};

export default StyledKPIChip;
